import { connect } from 'react-redux';
import { NoticeContainer as Component } from './NoticeContainer';
import { noticeSelector } from './selectors';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    notice: noticeSelector(state)
  };
};
export var NoticeContainer = connect(mapStateToProps)(Component);